import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import { ReconciliationPage } from "@/features/R1Dashboard/reconciliation/ui/ReconciliationPage";

export default function R1PositionsIssuersReconciliation() {
  useEffect(() => {
    setDocumentTitle("Quantilia | R1 Reconciliation");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <ReconciliationPage />
      </main>
    </R1DashboardProvider>
  );
}
